'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const components_display_Icon_Icon = require('../../display/Icon/Icon.cjs.js');

const root = "_root_1y8x1_1";
const styles = {
	root: root
};

const InteractiveTagIcon = ({ "aria-hidden": ariaHidden = true, "aria-label": ariaLabel, name, position }) => {
  const calculateLeftMargin = () => {
    if (name === "formX") {
      return position === "before" ? "-5px" : "0px";
    }
    return "0px";
  };
  const calculateRightMargin = () => {
    if (name === "formX") {
      return position === "after" ? "-5px" : "0px";
    }
    return "0px";
  };
  return jsxRuntime.jsx("div", { className: styles.root, "data-zds": true, style: {
    "--_zds-interactive-tag-icon-margin-left": calculateLeftMargin(),
    "--_zds-interactive-tag-icon-margin-right": calculateRightMargin()
  }, children: jsxRuntime.jsx(components_display_Icon_Icon.Icon, { "aria-hidden": ariaHidden, "aria-label": ariaLabel, name, size: 24 }) });
};

exports.InteractiveTagIcon = InteractiveTagIcon;
//# sourceMappingURL=InteractiveTagIcon.cjs.js.map
